import { Interface } from '@ethersproject/abi'
import { BigNumber } from '@ethersproject/bignumber'
import { ChainId, PAIRS_BY_CHAIN } from '../constants'
import { bigNumberFromHex } from '../utils'
import { useChainCalls } from './useChainCalls'
import { useEthers } from './useEthers'

const coder = new Interface(['function balanceOf (address) view returns (uint256)'])

export function useLiquidities() {
  const { chainId = ChainId.Mainnet, account } = useEthers()
  const pairs = PAIRS_BY_CHAIN[chainId].map((pair) => pair.address)
  const calls = account
    ? pairs.map((address) => ({
        address,
        data: coder.encodeFunctionData('balanceOf', [account]),
      }))
    : []
  const results = useChainCalls(calls)
  const result: { [address: string]: BigNumber } = {}
  for (let i = 0; i < results.length; i++) {
    const value = results[i]
    if (value) {
      result[pairs[i]] = bigNumberFromHex(value)
    }
  }
  return result
}
